module.exports = __webpack_public_path__ + "static/scale-model-of-carillon-historical-park-in-dayton-ohio-1b177317068ede7397e0ef1a3cdd63a2.png";